import { clubRoutes } from '@/router/routes/club.js';
import { competitionRoutes } from '@/router/routes/competition.js';
import { homeRoutes } from './home.js';
import { membershipRoutes } from '@/router/routes/membership.js';

export const routes = [
	clubRoutes,
	competitionRoutes,
	homeRoutes,
	membershipRoutes
];
